module.exports = __webpack_public_path__ + "static/media/video-03.546eef82.mp4";